<template>
  <DefaultBackground>
    <div class="mt-5 sm:mt-16 px-4 lg:flex lg:items-center lg:justify-center">
      <DefaultCard class="mb-8 lg:mb-0 mx-auto  max-w-8xl">
        <h1 class="font-semibold text-3xl text-center">Pricing</h1>
        <p class="mt-4">
          The table below lists the per user cost for Event and Program Owner
          licenses. These are the users that create, configure and administer
          events, projects and programs in BuildaBox.co. There is no cost for
          caterers, event vendors, team members and other collaborators to be
          added to and work on an event, program or project. All fees are paid
          monthly and can be cancelled at anytime directly through a user's
          account page. For organizations that would like to purchase multiple
          licenses, any user can add additional licenses through their account
          page and allocate them to others.
        </p>
        <OrderPriceTable :headersProp="headers" :datasetProp="dataset" class="max-w-8xl" />
      </DefaultCard>
    </div>
  </DefaultBackground>
</template>

<script>
import DefaultBackground from "@/components/common/layout/DefaultBackground";
import DefaultCard from "@/components/common/layout/DefaultCard";
import OrderPriceTable from "@/components/order/OrderPriceTable";

export default {
  name: "PricingPage",
  data() {
    return {
      headers: null,
      dataset: null
    };
  },
  components: { DefaultBackground, DefaultCard, OrderPriceTable },

  created() {
    this.headers = {
      title: ["Free", "Premium", "Team", "Business"],
      description: [
        "Use a full featured version of BuildaBox.co for free on smaller events, programs and projects. Limited to events with 25 attendees or less.",
        "For professionals and organizations that want to use BuildaBox.co without integrations.",
        "For professionals and organizations that want to use BuildaBox.co in connection with their CRM, ERP and other marketing technology.",
        "For medium and large sized organizations that have advanced needs."
      ],
      price: [0, 20, 40, "Custom Pricing"],
      button: ["Build A Box", "Get Started", "Get Started", "Contact Us"]
    };

    this.dataset = [
        {
          label: "Max Number of Attendees per Event or Program",
          values: [25, 100, 200, "Unlimited"]
        },
        {
          label: "Total Active Events Per Licensed Admin",
          values: [15, 25, 50, "Unlimited"]
        },
        {
          label: "Monthly Message Limit",
          values: [100, 500, 1000, "Unlimited"]
        },
        {
          label: "All Event Types",
          values: ["*", "*", "*", "*"]
        },
        {
          label: "BuildaBox.co App Usage",
          values: ["*", "*", "*", "*"]
        },
        {
          label: "Collaborator and Account Tools",
          values: ["", "*", "*", "*"]
        },
        {
          label: "Salesforce Integration",
          values: ["", "", "*", "*"]
        },
        {
          label: "Mailchimp Integration",
          values: ["", "", "", "*"]
        },
        {
          label: "Constant Contact Integration",
          values: ["", "", "", "*"]
        },
        {
          label: "Zoho Integrations",
          values: ["", "", "", "*"]
        },
        {
          label: "Custom Integrations",
          values: ["", "", "", "*"]
        },
        {
          label: "Dedicated Project Support",
          values: ["", "", "", "*"]
        }
      ];
  }
};
</script>

<style scoped></style>
